<template>
  <div class="current-resident-card" :class="{ preloading: preloadingFlag}">
    <div class="np--all col-lg-11" tabindex="0">
      <h3 class="current-resident-card__title">{{ title }}</h3>
      <div v-if="body" class="current-resident-card__body text--faux col-lg-9 np--all" v-html="body" />
    </div>
    <div class="current-resident-card__wrapper push-v--desktop--medium push-v--tablet--small push-v--mobile--small">
      <div class="current-resident-card__image-container">
        <KenticoResponsiveImage :src="image.url" :alt="image.description" class="current-resident-card__image" :sizes="imageSizes" />
      </div>
      <component :is="backgroundShape" :class="backgroundShapeClass" />
      <button v-if="video && callToVideoText" tabindex="0" class="current-resident-card__button btn--pale-yellow" @click="ctaClick">
        {{ callToVideoText }}<Arrow class="btn--arrow__icon btn--arrow__icon--orange" />
      </button>
      <call-to-action-button v-else-if="callToActionText" :external-link="externalLink" :call-to-action-link-text="callToActionText" :call-to-action-link="link" button-class="current-resident-card__button" />
    </div>
  </div>
</template>

<script>
import getStatic from '~/utils/get-static';
import ShapeCarousel1 from '~/assets/images/shapes/shape-carousel-1.svg?inline';
import ShapeCarousel2 from '~/assets/images/shapes/shape-carousel-2.svg?inline';
import ShapeCarousel3 from '~/assets/images/shapes/shape-carousel-3.svg?inline';
import CallToActionButton from '~/components/components/CallToActionButton';
import { BREAKPOINTS, BREAKPOINT_MD, BREAKPOINT_LG } from '~/utils/constants';
import { clickedPlayVideo } from '~/utils/gtm-events.js';

export default {
  components: {
    ShapeCarousel1,
    ShapeCarousel2,
    ShapeCarousel3,
    CallToActionButton,
  },
  props: {
    backgroundShape: { type: String, required: true },
    backgroundShapeClass: { type: String, required: true },
    callToVideoText: { type: String, required: false, default: 'Play Video' },
    callToActionText: { type: String, required: false, default: '' },
    externalLink: { type: String, default: '', required: false },
    link: {
      type: Object,
      default() {
        return {
          slug: '',
        };
      },
    },
    title: { type: String, required: true, default: '' },
    body: { type: String, default: '' },
    video: { type: String, default: '' },
    image: {
      type: Object,
      required: true,
      default() {
        return {
          url: { type: String, required: true, default: getStatic('/images/content/team/senior-management-1.png') },
          description: { type: String, required: true },
        };
      },
    },
  },
  data() {
    return {
      preloadingFlag: true,
      imageSizes: {
        default: [300, 250],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 300, height: 250 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 400, height: 334 },
        ],
      },
    };
  },
  mounted() {
    this.preloadingFlag = false;
  },
  methods: {
    ctaClick() {
      clickedPlayVideo(this.$gtm, this.title);
      this.$modal.show('video-modal', {
        video: this.video,
      });
      document.documentElement.style.overflow = 'hidden';
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_current-resident-card.scss';
</style>
